import { TerminationType } from 'features/call/call-base/enums';

interface TerminationDeciderProps {
  interpretTime: number;
  wasCallPlaced: boolean;
  terminationType: TerminationType;
  isH2DCall: boolean;
}

export const terminationDeciderVrs = ({
  interpretTime,
  wasCallPlaced,
  terminationType,
  isH2DCall,
}: TerminationDeciderProps) => {
  const originalTermReason = terminationType;

  if (originalTermReason === TerminationType.NonBill) {
    return originalTermReason;
  }

  const thereWasInterpretingTime = interpretTime > 0;
  if (thereWasInterpretingTime) {
    return isH2DCall && originalTermReason === TerminationType.SignMail
      ? TerminationType.SignMail
      : TerminationType.Normal;
  }

  if (wasCallPlaced) {
    return originalTermReason === TerminationType.Busy
      ? TerminationType.Busy
      : TerminationType.NoAnswer;
  }

  return TerminationType.ClNtPlcd;
};
